/* globals _ */

import api from './api';

const { noop } = _;

export function save( data, callback ) {
	callback = callback || noop;

	api( 'innoway/putJson', data, response => {
		callback( response.uid );
	}, 'POST' );
}

export function load( uid, callback ) {
	callback = callback || noop;

	api( 'innoway/getJson', { uid }, response => {
		callback( response );
	} );
}
